'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rowExpandContext = require('../contexts/row-expand-context');

var _rowExpandContext2 = _interopRequireDefault(_rowExpandContext);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (Component) {
  return function () {
    return _react2.default.createElement(_rowExpandContext2.default.Consumer, null, function (expandRow) {
      return _react2.default.createElement(Component, expandRow);
    });
  };
};